// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /entry/list-mine.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEntryListMineBody,
  typeEntryListMineOutput200,
} from "../../sdk/entry/postEntryListMine";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEntryListMineQueryKey(
  payload: typeEntryListMineBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  return ["post:entry:entryListMine", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEntryListMineOutput200,
    unknown,
    typeEntryListMineOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEntryListMine(
  payload: typeEntryListMineBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEntryListMineQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEntryListMine(payload),
    ...resolvedOptions,
  });
}
